import React from "react";
import PropTypes from "prop-types";

export default function StudioRotationHandle({
  visible = false,
  offset = 28,
  disabled = false,
  onPointerDown = null,
  label = "Faire pivoter la sélection",
}) {
  if (!visible) {
    return null;
  }

  const normalizedOffset =
    Math.max(0, Number(offset) || 0);

  return (
    <span
      className="studio-framework-rotation-control"
      style={{
        top: -normalizedOffset,
      }}
    >
      <span
        className="studio-framework-rotation-control__stem"
        aria-hidden="true"
      />

      <button
        type="button"
        className="studio-framework-rotation-handle"
        data-rotation-handle="selection"
        aria-label={label}
        disabled={disabled}
        onPointerDown={(event) => {
          event.preventDefault();
          event.stopPropagation();

          if (!disabled) {
            onPointerDown?.(event);
          }
        }}
      />
    </span>
  );
}

StudioRotationHandle.propTypes = {
  visible: PropTypes.bool,
  offset: PropTypes.number,
  disabled: PropTypes.bool,
  onPointerDown: PropTypes.func,
  label: PropTypes.string,
};
